// 组件类型
export const ComponentType = {
  swiper: 'cms_swiper',
  hotzone: 'cms_hotzone',
  anchor: 'cms_anchor',
  product: 'cms_product',
  word: 'cms_word'
}

// 组件文本
export const ComponentText = {
  [ComponentType.swiper]: '轮播组件',
  [ComponentType.hotzone]: '热区组件',
  [ComponentType.anchor]: '锚点组件',
  [ComponentType.product]: '商品组件',
  [ComponentType.word]: '文字组件'
}
